{
  "id": "campaign-048",
  "name": "Clover Paddock",
  "seed": "campaign:48",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......RRRRRR",
    "......RRRRRR",
    "......______",
    "............",
    "....vvv...x.",
    "....vvv.....",
    "ffffffffff..",
    "......e.....",
    "......e.....",
    ".y,...e.Tvvv",
    "......e..vvv",
    "..........y.",
    "y..y.T......",
    "......#.ccc.",
    "....T.......",
    "S..........."
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 7,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 11,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 12
    },
    {
      "kind": "rare",
      "x": 10,
      "y": 2
    }
  ],
  "generatorVersion": 3,
  "level": 48,
  "biome": "farm",
  "par": {
    "reel": 6718,
    "push": 5629,
    "selfPropelled": 5094,
    "tractor": 4445,
    "zeroTurn": 3380,
    "fairway": 2132
  },
  "routeTries": {
    "par": {
      "reel": 3,
      "push": 8,
      "selfPropelled": 9,
      "tractor": 19,
      "zeroTurn": 22,
      "fairway": 1
    }
  }
}
